import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../core/modules/shared.module';
import { RouterModule } from '@angular/router';

import { FuseMaintenanceComponent } from './maintenance.component';

const routes = [
    {
        path     : 'pages/maintenance',
        component: FuseMaintenanceComponent
    }
];

@NgModule({
    declarations: [
        FuseMaintenanceComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ]
})

export class MaintenanceModule
{

}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/maintenance/maintenence.module.ts